{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Nova mensagem",
  "chat.scrollToBottom": "Rolar para o final",
  "messagefeedback.thumbDown": "Resposta ruim",
  "messagefeedback.thumbUp": "Resposta boa",
  "promptfield.aiDisclaimer": "As respostas são geradas usando IA e podem ser imprecisas. Verifique antes de usar.",
  "promptfield.aiUserGuidlines": "Diretrizes de usuário de IA",
  "promptfield.attachments": "Anexos",
  "promptfield.insertButton": "Adicionar",
  "promptfield.label": "Solicitar",
  "promptfield.placeholder": "Pronto para começar? Faça uma pergunta, compartilhe uma ideia ou adicione uma tarefa.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Parar",
  "promptfield.submitButton": "Enviar",
  "promptfield.uploading": "Carregando",
  "responsestatus.loading": "Carregando",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Iniciar gravação",
  "voicebutton.stopListening": "Parar gravação",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
